import Tpl from "./Tpl";
import {broadcastSendBTContext, onBroadcastNeedBTContext, VideoBridgeInit} from "../../api";
import {hideView, setViewAlpha, setViewScale, showView} from "../../api/nativeComponent/compVisibleCommon";

export default class BigTpl extends Tpl {
    constructor(arg = {
        // campaignList: [],
        unit: {}
    }) {
        super(arg)

        // 表明当前模板如果要成功加载, 至少需要多少个 campaign
        this.expectCampaignNumber = 2

        // 存储通过当前大模板创建的子模板列表
        this.tplList = []
        this.tplIndexList = []

        this.unit = arg.unit || {}

        this.campaignList = []
    }

    init({JsBridgeRes}) {
        super.init({JsBridgeRes});

        window.onBroadcastNeedBTContext = onBroadcastNeedBTContext
        onBroadcastNeedBTContext({
            cb: async res => {
                console.log('监听到子模板对 BTContext 的需求', res)
                let subTplId = res.param.data.subTplId
                let data = {
                    subTplId,
                    MTG_SDKContext
                }
                console.log('开始广播 BTContext', data)
                await broadcastSendBTContext({unitId: this.unitId, data})
            }
        })
    }

    allTplPreloadFinished() {
        let isAllFinished = true
        for (let curTplItem of this.tplIndexList) {
            if (curTplItem.isPageLoadFinished === false) {
                isAllFinished = false
            }
        }
        return isAllFinished
    }

    show(res) {
        super.show(res)
    }


}